export const UNSUBMITTED = 'unsubmitted';
export const PENDING = 'pending';
export const PREPPED = 'prepped';
export const PACKED = 'packed';
export const SHIPPED = 'shipped';
export const CANCELLED = 'canceled';
export const RUSH = 'rush';
